import { YPaymentAmount, YMultiCurrencyAmount, $amount } from '../y/amount';
import { YI18NString, YI18NStrings } from '../y/i18n';
import { YCountryId } from '../y/types';
import { CPaidPlanId } from './c-user';
import { getCountry } from '../me/me';
import { PPromo, PPromoEffectSubscription } from './p-promo';

export interface CPlan {
    id: CPaidPlanId;
    name: YI18NString;
    signup: boolean;
    tickets: number;
    price: { [country in YCountryId]: YPaymentAmount };
    points: YI18NStrings;
}

export function cPlanReferralDiscount(): YPaymentAmount {
    if(getCountry() == 'SE')
        return { value: 10000, currency: 'SEK' }
    else
        return { value: 1000, currency: 'EUR' }
}

export function cPlanDiscountedPrice(plan: CPlan, promo?: PPromo): YPaymentAmount {
    const price = plan.price[getCountry()];
    let discount: YMultiCurrencyAmount | undefined;
    if(promo) {
        for(const e of promo.effect) {
            if(e.kind == 'subscription_discount') {
                discount = e.subscription_discount[plan.id];
                break;
            }
        }
    }

    return discount ? $amount.add(price, $amount.getInCurrency(discount, price.currency)) : price;
}

export function cPlanPromoEffectPrice(plan: CPlan, effect: PPromoEffectSubscription): YPaymentAmount {
    const base = plan.price[getCountry()];

    const plan_price = effect.subscription_price[plan.id];
    if(plan_price?.[base.currency] != undefined) {
        return { value: plan_price[base.currency], currency: base.currency };
    }

    return base;
}
